<template>
  <div class="function">
    <div class="open list" @click="open = !open">
      <img src="../assets/img/close1.png" class="icon" v-if="!open" />
      <img src="../assets/img/open.png" class="icon" v-if="open" />
    </div>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft"
    >
      <div v-if="open">
        <div v-for="(item, index) in functionList" :key="index" @click="change(index)">
          <div class="list">
            <img src="../assets/img/icon_open.png" class="icon" v-if="index == value" />
            <img src="../assets/img/icon_normal.png" class="icon" v-else />

            <div class="name">
              <p class="p1">{{ item.name }}</p>
              <p class="p2">{{ item.ename }}</p>
            </div>

            <div class="shadow"></div>
          </div>
          <transition
            name="custom-classes-transition"
            enter-active-class="animated fadeInLeft"
          >
            <div v-if="value == index">
              <div
                :class="['list1', 'list', index == 1 ? 'list2' : '']"
                v-for="(item1, index1) in item.list"
                :key="index1"
                @click.stop="change1(item1, index1, value)"
              >
                <div class="shadow"></div>
                <img
                  src="../assets/img/icon_fanhui.png"
                  class="icon"
                  v-if="value1 == index1"
                />
                <img src="../assets/img/icon_normal.png" class="icon" v-else />

                <div class="name">
                  <p class="p1">{{ item1.name }}</p>
                  <p class="p2">{{ item1.ename }}</p>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Bus from "../../common/js/bus";
export default {
  data() {
    return {
      value: 999,
      value1: 999,
      open: true,
      functionList: [
        {
          name: "关于我们",
          ename: "ABOUT US",
          list: [
            {
              name: "公司介绍",
              ename: "Profiles",
            },
            // {
            //     name: "客户成就",
            //     ename: "CLIENTS",
            //   },
            //   {
            //     name: "获得荣誉",
            //     ename: "AWARDED PRIZED",
            //   },
            {
              name: "团队成员",
              ename: "Our Team",
            },
            {
              name: "联系我们",
              ename: "Contact Us",
            },
          ],
        },

        {
          name: "软件技术",
          ename: "SOFTWARE",
          list: [
            {
              name: "室内设计引擎",
              ename: "Design Engine",
            },
            {
              name: "木作参数引擎",
              ename: "Furniture Engine",
            },
            {
              name: "交互编辑器",
              ename: "Editor",
            },
            {
              name: "webgl引擎",
              ename: "WebGL Engine",
            },
          ],
        },
        {
          name: "硬件展示",
          ename: "HARDWARE",
          list: [
            {
              name: "智能桌面",
              ename: "Desktop",
            },
            {
              name: "AR沙盘",
              ename: "AR Sandbox",
            },
            {
              name: "vr头盔",
              ename: "VR Glasses",
            },
            {
              name: "IPAD",
              ename: "Ipad",
            },
            {
              name: "手机",
              ename: "Phone",
            },
            {
              name: "STUDIO",
              ename: "Studio",
            },
          ],
        },
        {
          name: "解决方案",
          ename: "Solutions",

          list: [
            {
              name: "军工",
              ename: "Military",
            },
            {
              name: "教育",
              ename: "Education",
            },
            {
              name: "家装",
              ename: "Renovation",
            },
            {
              name: "数字孪生",
              ename: "Digital twin",
            },

            // {
            //   name: "数字人",
            //   ename: "Military",
            // },
            // {
            //   name: "AI体检",
            //   ename: "Education",
            // },
            // {
            //   name: "VR全景",
            //   ename: "Renovation",
            // },
            // {
            //   name: "电话精灵",
            //   ename: "Digital twin",
            // },
          ],
        },

        {
          name: "案例展示",
          ename: "cases",
          list: [],
        },
        // {
        //   name: "案例展示",
        //   ename: "CASES",
        //   list: ["公司介绍", "客户成就", "获得荣誉", "团队成员", "分享"],
        // },
      ],
    };
  },
  methods: {
    change(e) {
      if (this.value == e) {
        console.log("close");
        this.value = 999;
      } else {
        this.value = e;
      }
      this.value1 = 999;
      Bus.$emit("vFlag1", e);
      Bus.$emit("boxClose", true);
      document.o2.adminClick("change", e);
    },
    change1(x, y, z) {
      console.log(x, y);
      Bus.$emit("item", [z, y, x]);
      Bus.$emit("vFlag2", x.name);
      this.value = z;
      this.value1 = y;
      document.o2.adminClick("change1", JSON.stringify([x, y, z]));
    },
    end() {
      this.value = 999;
      this.value1 = 999;
      document.o2.adminClick("end", "");
    },
  },
  created() {
    Bus.$on("close", (target) => {
      if (target) this.end();
    });

    Bus.$on("change", (x, y) => {
      console.log(x, y);
      if (x == "change") {
        this.change(y);
      } else if (x == "change1") {
        var list = JSON.parse(y);
        this.change1(list[0], list[1], list[2]);
      } else if (x == "end") {
        this.end();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.function {
  position: absolute;
  top: 30px;
  left: 0;
  z-index: 99;
  .list {
    width: 140px;
    height: 51px;
    background: rgba($color: #fff, $alpha: 0.8);
    border-radius: 0px 25px 25px 0;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 20px;
    position: relative;
    // filter: blur(10px);
    // -webkit-filter: blur(10px);
    // -moz-filter: blur(10px);
    // -ms-filter: blur(10px);
    // -o-filter: blur(10px);

    .icon {
      width: 26px;
      height: 26px;
      margin: 13px;
      position: relative;
      z-index: 2;
    }
    .p1 {
      font-size: 18px;
      font-family: SimHei;
      font-weight: bold;
      color: #4b4b4b;

      text-align: right;
      position: relative;
      z-index: 2;
    }
    .p2 {
      font-size: 9px;
      font-family: SimHei;
      font-weight: bold;
      color: #808080;
      z-index: 2;
      position: relative;
    }

    // .shadow {
    //   width: 100%;
    //   height: 100%;
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   background: rgba($color: #fff, $alpha: 0.6);
    //   filter: blur(4px);
    //   -webkit-filter: blur(10px);
    //   -moz-filter: blur(10px);
    //   -ms-filter: blur(10px);
    //   -o-filter: blur(10px);
    //   z-index: 1;
    //   border-radius: 0px 25px 25px 0;
    // }
  }

  .list1 {
    width: 112px;
    height: 44px;

    .icon {
      width: 22px;
      height: 22px;
      margin: 8px;
    }
    .p1 {
      font-size: 12px;
      font-family: SimHei;
      font-weight: bold;
    }
    .p2 {
      font-size: 8px;
      font-family: SimHei;
      font-weight: bold;
      color: #808080;
      transform: scale(0.7);
    }
  }
  .list2 {
    width: 120px;

    .p2 {
      font-size: 8px;
      font-family: SimHei;
      font-weight: bold;
      color: #808080;
      width: 200%;
      margin-right: 40px;
      transform: scale(0.7);
      text-align: left;
    }
  }

  .open {
    width: 50px;
  }
}

@media screen and (max-width: 450px) {
  .function {
    .list {
      transform: scale(0.7);
      left: -22px;
      margin-bottom: 0px;
    }
  }
}
</style>
